import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";



export default function WartungsprotokollSeite7({ form, setForm }) {

    const [showZusatz1, setShowZusatz1] = useState(false);
    const [showZusatz2, setShowZusatz2] = useState(false);

  if (
    !form ||
    !form.pruefungZaehler ||
    !form.zusatzZaehler ||
    !form.pruefungUeberwachung ||
    !form.zusatzUeberwachung
  ) return null;

  // Checkbox updater for section rows
  const updateRow = (section, index, field) => {
    setForm(prev => {
      const updated = [...prev[section]];
      updated[index][field] = !updated[index][field];
      return { ...prev, [section]: updated };
    });
  };

  // Text + checkbox updater for Zusatz-Tabellen
  const updateZusatz = (section, index, field, value) => {
    setForm(prev => {
      const updated = [...prev[section]];
      updated[index][field] = value;
      return { ...prev, [section]: updated };
    });
  };

  return (
    
    <div className="p-6 text-sm">
      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
      {/* ===================== SECTION 9 ===================== */}
      <h2 className="text-lg font-semibold mb-4">9 Prüfung Zähler (Foto Zählerstand!)</h2>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
                 <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {[
            "9.1 Der Zähler ist funktionsfähig",
            "9.2 Zählerstand 2.8.0 (alternativ 2.8.1 und 2.8.2, oder Lieferung PV)",
            "9.3 Umrechnungsfaktor Zähler",
            "9.4 Zähler Nr."
          ].map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungZaehler?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungZaehler || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungZaehler: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungZaehler?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungZaehler || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungZaehler: list };
                    })
                  }
                />
              </td>

              {/* Nicht zutreffend */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungZaehler?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungZaehler || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungZaehler: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

               <Box mb={3} mt={4}>
            
                    <Button
                      onClick={() => setShowZusatz1(!showZusatz1)}
                      colorScheme="blue"
                      borderRadius="lg"
                    >
                      {showZusatz1 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
                    </Button>
            
               </Box>


      {/* ============== ZUSATZ-TABELLE #1 ============== */}
      {showZusatz1 && (
        <>
      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen / Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {form.zusatzZaehler.map((row, idx) => (
            <tr key={idx}>
              {/* Text fields */}
              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row[field]}
                    onChange={e => updateZusatz("zusatzZaehler", idx, field, e.target.value)}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#f7f7fb",
                      height: "18px"
                    }}
                  />
                </td>
              ))}

              {/* Plan checkbox */}
              <td style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={() => updateZusatz("zusatzZaehler", idx, "plan", !row.plan)}
                />
              </td>

              {/* Bild-Nr */}
              <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz("zusatzZaehler", idx, "bildnr", e.target.value)}
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f7f7fb",
                    height: "18px"
                  }}
                />
              </td>

              {/* Beh + n.Beh */}
              {["beh", "nbeh"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row[field]}
                    onChange={() => updateZusatz("zusatzZaehler", idx, field, !row[field])}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
         </>
       )}
      </Box>

     <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
      {/* ===================== SECTION 10 ===================== */}
      <h2 style={{ fontWeight: "bold" }}>10 Prüfung Überwachungssystem</h2>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
                 <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {[
            "10.1 Die Datenlogger sind in Betrieb ohne Störungsmeldungen",
            "10.2 Der Router ist in Betrieb ohne Störungsmeldungen",
            "10.3 Die ÜW-Schnittstelle ist in Betrieb ohne Störungsmeldungen",
            "10.4 Das Netzwerk ist in Betrieb",
            "10.5 Die Überwachungsverteiler sind frei von Schäden und Feuchtigkeit",
            "10.6 Die Beschriftung der ÜW-Verteiler ist in Ordnung",
            "10.7 Die Werte aller WR werden übertragen (prüfen mit Überwachungszentrale)",
            "10.8 Die Einstrahlungssensoren und deren Kabel sind frei von Schäden",
            "10.9 Die Oberfläche der Einstrahlungssensoren wurde gereinigt",
            "10.10 Die Temperatursensoren und deren Kabel sind frei von Schäden",
          ].map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
              
                <input
                  type="checkbox"
                  checked={form.pruefungUeberwachung?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungUeberwachung || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungUeberwachung: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
              
                <input
                  type="checkbox"
                  checked={form.pruefungUeberwachung?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungUeberwachung || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungUeberwachung: list };
                    })
                  }
                />
              </td>

              {/* n.z. */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                
                <input
                  type="checkbox"
                  checked={form.pruefungUeberwachung?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungUeberwachung || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungUeberwachung: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>


          <Box mb={3} mt={4}>
            
                    <Button
                      onClick={() => setShowZusatz2(!showZusatz2)}
                      colorScheme="blue"
                      borderRadius="lg"
                    >
                      {showZusatz2 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
                    </Button>
            
          </Box>


      {/* ============== ZUSATZ-TABELLE #2 ============== */}

        {showZusatz2 && (
        <>

      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen / Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {form.zusatzUeberwachung.map((row, idx) => (
            <tr key={idx}>
              {["zupunkt", "bemerkung", "standort"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                  <input
                    type="text"
                    value={row[field]}
                    onChange={e => updateZusatz("zusatzUeberwachung", idx, field, e.target.value)}
                    style={{
                      width: "100%",
                      border: "none",
                      backgroundColor: "#f7f7fb",
                      height: "18px"
                    }}
                  />
                </td>
              ))}

              <td style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={() => updateZusatz("zusatzUeberwachung", idx, "plan", !row.plan)}
                />
              </td>

              <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz("zusatzUeberwachung", idx, "bildnr", e.target.value)}
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "#f7f7fb",
                    height: "18px"
                  }}
                />
              </td>

              {["beh", "nbeh"].map(field => (
                <td key={field} style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={row[field]}
                    onChange={() => updateZusatz("zusatzUeberwachung", idx, field, !row[field])}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

             </>
       )}

      </Box>

    </div>
  
  );
}